"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _models = require("@seedlang/models");
var _utils = require("@seedlang/utils");
var _root_store = _interopRequireDefault(require("./root_store"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var ConceptStore = /*#__PURE__*/function (_RootStore) {
  function ConceptStore() {
    var _this;
    (0, _classCallCheck2["default"])(this, ConceptStore);
    _this = _callSuper(this, ConceptStore);
    _this.config = {
      model: _models.Concept,
      deserialize: true,
      GET: {
        index: '/concepts',
        show: '/concepts/:conceptId'
      },
      POST: {
        create: '/concepts'
      },
      PUT: {
        update: '/concepts/:conceptId',
        refresh: '/concepts/:conceptId/refresh',
        deleteSentenceVideos: '/concepts/:conceptId/delete_sentence_videos',
        copy: '/concepts/:conceptId/copy',
        evaluateHasAllVideoClips: '/concepts/:conceptId/evaluate_has_all_video_clips',
        evaluateHasAllSupplements: '/concepts/:conceptId/evaluate_has_all_supplements',
        addAllRoots: '/concepts/:conceptId/add_all_roots',
        clearAllRoots: '/concepts/:conceptId/clear_all_roots'
      },
      DELETE: {
        destroy: '/concepts/:conceptId'
      }
    };
    return _this;
  }
  (0, _inherits2["default"])(ConceptStore, _RootStore);
  return (0, _createClass2["default"])(ConceptStore, [{
    key: "refresh",
    value: function refresh(params, callback) {
      this.api(params, callback, 'PUT', 'refresh');
    }
  }, {
    key: "copy",
    value: function copy(params, callback) {
      this.api(params, callback, 'PUT', 'copy');
    }
  }, {
    key: "deleteSentenceVideos",
    value: function deleteSentenceVideos(params, callback) {
      this.api(params, callback, 'PUT', 'deleteSentenceVideos');
    }
  }, {
    key: "evaluateHasAllVideoClips",
    value: function evaluateHasAllVideoClips(params, callback) {
      this.api(params, callback, 'PUT', 'evaluateHasAllVideoClips');
    }
  }, {
    key: "addAllRoots",
    value: function addAllRoots(params, callback) {
      this.api(params, callback, 'PUT', 'addAllRoots');
    }
  }, {
    key: "clearAllRoots",
    value: function clearAllRoots(params, callback) {
      this.api(params, callback, 'PUT', 'clearAllRoots');
    }
  }, {
    key: "filterWordType",
    value: function filterWordType(id) {
      return this.indexData.filter(function (item) {
        return (0, _utils.isPresent)(item.wordType) && item.wordType.id === id;
      });
    }
  }]);
}(_root_store["default"]);
var _default = exports["default"] = new ConceptStore();